import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { ShieldCheck } from 'lucide-react';
import { toast } from 'sonner';

export default function AdminLoginPage() {
    const { loginAdmin, role } = useAuth();
    const nav = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [err, setErr] = useState('');
    const [busy, setBusy] = useState(false);

    useEffect(() => { if (role === 'superadmin') nav('/superadmin/dashboard', { replace: true }); }, [role, nav]);

    const submit = async (e) => {
        e.preventDefault();
        setErr('');
        setBusy(true);
        try {
            await loginAdmin(email.trim(), password);
            toast.success('Bienvenido, administrador');
            nav('/superadmin/dashboard', { replace: true });
        } catch (e) {
            setErr(e?.response?.data?.detail || 'Error');
        } finally { setBusy(false); }
    };

    return (
        <div className="min-h-screen flex">
            <div className="hidden lg:flex flex-1 admin-halo items-center justify-center px-10">
                <div className="max-w-md">
                    <ShieldCheck className="h-8 w-8 text-[hsl(var(--primary))] mb-4" />
                    <h1 className="text-3xl font-semibold tracking-tight">Panel de Superadministrador</h1>
                    <p className="mt-2 text-muted-foreground">Control total de la plataforma: usuarios, anuncios, comisiones, categorías y configuración de Stripe.</p>
                </div>
            </div>
            <div className="flex-1 flex items-center justify-center px-4 py-10">
                <form onSubmit={submit} className="w-full max-w-sm space-y-4">
                    <div>
                        <h2 className="text-2xl font-semibold tracking-tight">Iniciar sesión</h2>
                        <p className="text-sm text-muted-foreground">Acceso restringido a administradores.</p>
                    </div>
                    <div>
                        <Label>Email</Label>
                        <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="admin@ejemplo.com" data-testid="admin-email" autoFocus />
                    </div>
                    <div>
                        <Label>Contraseña</Label>
                        <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password" />
                    </div>
                    {err && <p className="text-sm text-destructive">{err}</p>}
                    <Button type="submit" className="w-full" disabled={busy} data-testid="admin-login-submit">{busy ? 'Ingresando…' : 'Entrar'}</Button>
                </form>
            </div>
        </div>
    );
}
